import { useParams } from 'react-router-dom'
import { useDocContent } from '../../hooks/useDocContent'

interface DocsContentProps {
  docPath: string
}

function DocsContent({ docPath }: DocsContentProps) {
  const { section } = useParams()

  // If there's a section param, construct the full path
  const fullPath = section ? `${docPath}/${section}` : docPath

  const Content = useDocContent({ docPath: fullPath })

  return (
    <div className='docs-content-wrapper'>
      <Content />
    </div>
  )
}

export default DocsContent
